import { useEffect, useState } from "react"
import TableHeader from "../Components/TableHeader"
import core from "../core";
import { Download, ThreeDotsVertical } from "react-bootstrap-icons";
import TableLoader from "../Components/TableLoader";
import OutsideClickHandler from "react-outside-click-handler";
import TableFoot from "../Components/TableFoot";
import axios from "axios";
import { Modal } from "react-bootstrap";

const WonCars = ({setNotification}) => {
    const query = core.useQuery();
    const [modals, setModals] = useState({});
    const [sortBy, setSortBy] = useState([]);
    const [checkboxes, setCheckboxes] = useState([]);
    const [filter, setFilter] = useState({page: query.page ? query.page : "1", limit: query.limit ? query.limit : 10, keyword: query.keyword ? query.keyword : "", 
        sort_by: query.sort_by ? query.sort_by : "id", sort_order: query.sort_order ? query.sort_order : "DESC", auction: query.auction ? query.auction : "", 
        admin: query.admin ? query.admin : "", start_date: query.start_date ? query.start_date : "", end_date: query.end_date ? query.end_date : ""});
    const [logsHistory, setLogsHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState("");
    const [total, setTotal] = useState(0);
    const [exportLoad, setExportLoad] = useState(false);
    const [exportLimit, setExportLimit] = useState({modal: false, limit: "10"});

    const handlers = {

    }

    useEffect(() => {
        axios('/api/extension/v1/options?name=bids-sort-by')
            .then((res) => {
                const data = res.data.data;
                setSortBy(typeof data == "string" ? JSON.parse(data) : data);
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }, []);

    function exportWonCars(){
        setExportLoad(true);
        axios.get(`/api/extension/v1/export/won-vehicles?page=${filter.page}&limit=${exportLimit.limit}&keyword=${filter.keyword}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}&auction=${filter.auction}&admin=${filter.admin}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
            .then((res) => {
                const host = window.location.hostname.replace('.ge/', ".ge");
                const url = `${host}${res.data.url}`;
                window.open(url, "_blank")
                setExportLoad(false);
                setExportLimit((prev) => ({...prev, modal: false}))
            })
            .catch((err) => {
                setExportLoad(false);
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }

     useEffect(() => {
        setLoading(true);
        axios(`/api/extension/v1/won-vehicles?page=${filter.page}&limit=${filter.limit}&keyword=${filter.keyword}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}&auction=${filter.auction}&admin=${filter.admin}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
            .then((res) => {
                const data = res.data.data;
                setLogsHistory(data)
                const count = res.data.total;
                const pageCount = count <= filter.limit ? 1 : (count % filter.limit == 0 ? count / filter.limit : parseInt(count / filter.limit) + 1);
                setTotal(pageCount);
                setLoading(false)
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
                setLoading(false);
            })
     }, [filter])

    return(
        <div className="page-content-container">
            <h2 className="page-title">Won Cars</h2>
            <TableHeader setNotification={setNotification} exportHandler={() => setExportLimit((prev) => ({...prev, modal: true}))} exportLoad={exportLoad} setExportLoad={setExportLoad} setModals={setModals} filter={filter} withoutAddNew={true} AddNewButtonIcon={Download} sortBy={sortBy} exportButton={true} checkboxes={checkboxes} setFilter={setFilter} />
            <table className="responsive-d-table">
                <thead>
                    <tr>
                        <th>Lot</th>
                        <th>Bidder</th>
                        <th>Sale Date</th>
                        <th>Location</th>
                        <th>Name</th>
                        <th>bid</th>
                        <th>Title Status</th>
                        <th>Buyer</th>
                        <th>Auction</th>
                        <th>Admin</th>
                        <th>IP Address</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (!loading && logsHistory.length > 0) && logsHistory.map((logs, id) => {
                            return <tr key={logs.id} className={(id + 2) % 2 == 0 ? "even-row" : "odd-row"}>
                                <td>{logs.lot}</td>
                                <td>{logs.bidder}</td>
                                <td>{core.formdatDate(new Date(logs.sale_date), "yyyy-mm-dd")}</td>
                                <td>{logs.location}</td>
                                <td>{logs.name}</td>
                                <td>{logs.bid}</td>
                                <td>{logs.vin}</td>
                                <td>{logs.buyer}</td>
                                <td>{logs.auction}</td>
                                <td>{logs.admin}</td>
                                <td>{logs.ip_address}</td>
                            </tr>
                        })
                    }
                    {
                        (!loading && logsHistory.length == 0) && <tr style={{background: "#494646ff"}}>
                            <td colSpan={11}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>
                    }
                    {
                        loading && <TableLoader colspan={11}/>
                    }
                </tbody>
            </table>
            <TableFoot  filter={filter} setFilter={setFilter} count={total} />
            <Modal show={exportLimit.modal} onHide={() => setExportLimit((prev) => ({...prev, modal: false}))}>
                <Modal.Header closeButton><h5 style={{color: "#afb9cf"}}>Export Data Limit</h5></Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="form-group" style={{padding: "0"}}>
                                <label>Select Limit</label>
                                <select value={exportLimit.limit} onChange={(e) => setExportLimit((prev) => ({...prev, limit: e.target.value}))} className="form-control">
                                    <option>Select Limit</option>
                                    <option value={50000}>All</option>
                                    <option value={10}>10</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={200}>200</option>
                                </select>
                            </div>
                            <button disabled={exportLoad} style={{marginLeft: "0", marginTop: "20px"}} onClick={exportWonCars} className="export-button">{exportLoad ? <div className="button-loader"></div> : "Export"}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default WonCars